import { useState } from 'react';
import { sendContact } from '../api/client.js';
import { BRAND } from '../data/constants.js';
import { useSearchParams } from 'react-router-dom';

export default function Contact() {
  const [sp] = useSearchParams();
  const asunto = sp.get('asunto');
  const [d, setD] = useState({ nombre:'', contacto:'', mensaje: asunto==='permuta'?'Hola, consulto por una permuta.':'', consent:false });
  const [er, setEr] = useState({});
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const upd = (k,v) => setD(s=>({...s,[k]:v}));
  const submit = async(e) => {
    e.preventDefault();
    const errs = {};
    if (!d.nombre.trim())   errs.nombre   = 'Decinos tu nombre';
    if (!d.contacto.trim()) errs.contacto = 'Dejá un teléfono o email';
    if (!d.consent)         errs.consent  = 'Necesitamos tu consentimiento';
    setEr(errs); if (Object.keys(errs).length) return;
    setLoading(true);
    try { await sendContact({ name:d.nombre, phone:d.contacto, email:d.contacto, message:d.mensaje }); setSent(true); }
    catch(err) { setEr({ submit: err.message }); }
    finally { setLoading(false); }
  };
  return (
    <div className="page contacto">
      <div className="container">
        <div className="page-head">
          <span className="kicker">Contacto</span>
          <h1 className="page-h1">Hablemos</h1>
          <p className="page-sub">Contanos qué necesitás y te respondemos a la brevedad.</p>
        </div>
        <div className="contacto-grid">
          <div className="contacto-info">
            <a className="ci-line" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener"><div className="ci-ic">💬</div><div><b>Ventas</b><span>{BRAND.phoneVentas}</span></div></a>
            <a className="ci-line" href={`https://wa.me/${BRAND.waAlquileres}`} target="_blank" rel="noopener"><div className="ci-ic">💬</div><div><b>Alquileres</b><span>{BRAND.phoneAlquileres}</span></div></a>
            <a className="ci-line" href={`mailto:${BRAND.email}`}><div className="ci-ic">✉</div><div><b>Email</b><span>{BRAND.email}</span></div></a>
            <div className="ci-line"><div className="ci-ic">📍</div><div><b>Oficina</b><span>{BRAND.address}</span></div></div>
            <div className="ci-line"><div className="ci-ic">🕐</div><div><b>Horarios</b><span>{BRAND.hours}</span></div></div>
            <div className="ci-soc">
              <a href={BRAND.instagram} target="_blank" rel="noopener" aria-label="Instagram">IG</a>
              <a href={BRAND.facebook}  target="_blank" rel="noopener" aria-label="Facebook">FB</a>
            </div>
          </div>
          <div className="contacto-form">
            {sent ? (
              <div className="cf-sent"><div className="cf-sent-ic">✓</div><h4>¡Gracias por tu consulta!</h4><p>Te contactamos a la brevedad.</p><a className="btn btn-wa btn-block" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Ir a WhatsApp</a></div>
            ) : (
              <form className="cf" onSubmit={submit} noValidate>
                <div className="field"><label htmlFor="co-n">Nombre</label><input id="co-n" className={"input"+(er.nombre?" err":"")} value={d.nombre} onChange={e=>upd('nombre',e.target.value)} placeholder="Tu nombre" />{er.nombre&&<span className="field-err">{er.nombre}</span>}</div>
                <div className="field"><label htmlFor="co-c">Teléfono o email</label><input id="co-c" className={"input"+(er.contacto?" err":"")} value={d.contacto} onChange={e=>upd('contacto',e.target.value)} placeholder="+54 11 …" />{er.contacto&&<span className="field-err">{er.contacto}</span>}</div>
                <div className="field"><label htmlFor="co-m">Mensaje</label><textarea id="co-m" className="input" rows={4} value={d.mensaje} onChange={e=>upd('mensaje',e.target.value)} placeholder="¿En qué te podemos ayudar?" /></div>
                <label className={"cf-consent"+(er.consent?" err":"")}><input type="checkbox" checked={d.consent} onChange={e=>upd('consent',e.target.checked)} /><span className="fc-box">{d.consent&&'✓'}</span><span>Acepto ser contactado por Abriola sobre esta consulta.</span></label>
                {er.submit&&<p className="field-err">{er.submit}</p>}
                <button className="btn btn-primary btn-block cf-submit" type="submit" disabled={loading}>{loading?'Enviando…':'Enviar consulta →'}</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
